import { NgModule } from '@angular/core'
import { ApplyClassIfFeatureFlagDisabledDirective } from '~app/features/launch-darkly/apply-class-if-feature-flag-disabled.directive'
import { ApplyClassIfFeatureFlagEnabledDirective } from '~app/features/launch-darkly/apply-class-if-feature-flag-enabled.directive'
import { LaunchDarklyFeatureFlagDisabledDirective } from '~app/features/launch-darkly/launch-darkly-feature-flag-disabled.directive'
import { LaunchDarklyFeatureFlagEnabledDirective } from './launch-darkly-feature-flag-enabled.directive'
import { LaunchDarklyService } from './launch-darkly.service'

@NgModule({
  declarations: [
    LaunchDarklyFeatureFlagEnabledDirective,
    LaunchDarklyFeatureFlagDisabledDirective,
    ApplyClassIfFeatureFlagEnabledDirective,
    ApplyClassIfFeatureFlagDisabledDirective,
  ],
  providers: [LaunchDarklyService],
  exports: [
    LaunchDarklyFeatureFlagEnabledDirective,
    LaunchDarklyFeatureFlagDisabledDirective,
    ApplyClassIfFeatureFlagEnabledDirective,
    ApplyClassIfFeatureFlagDisabledDirective,
  ],
})
export class LaunchDarklyModule {}
